import instance from 'api';
import { IBigAppDownloadLink } from './interfaces';

export const sendBigAppDownloadLink = (data: IBigAppDownloadLink) => {
  return instance()
    .post(`SMS/sendBigAppLink`, data)
    .then((response) => response.data);
};
